import { ReactNode } from 'react';

import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { Link } from '@/libraries/design/components/link/src/link';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';

import { messages } from './messages';

const containerCss = css({
	fontSize: '0.75rem',
	lineHeight: '1.125rem',
	marginBlockStart: '1rem',
	marginBlockEnd: '100px',
	textAlign: 'center',
	padding: '0 60px',
});

export const PaidJiraAiDisclaimer = () => {
	const acceptableUsePolicyLinkHref = useLocalizedHref('/legal/acceptable-use-policy');

	return (
		<div css={containerCss}>
			<FormattedMessage
				{...messages.acceptableUsePolicyDisclaimer}
				values={{
					acceptableUsePolicyLink: (text: ReactNode) => (
						<Link
							type="inline"
							text={text as string}
							aria-label={text as string}
							href={acceptableUsePolicyLinkHref}
						/>
					),
				}}
			/>
		</div>
	);
};
